/**
 * Ключи в сцене для данных записей зависят от viewMode (table, calendar, cards, reports).
 * Table использует старые имена полей для обратной совместимости.
 */
const isTable = (viewMode) => !viewMode || viewMode === 'table';

function keyFor(viewMode, tableKey, suffix) {
  return isTable(viewMode) ? tableKey : `${viewMode}${suffix}`;
}

export function getRecordsKey(viewMode) {
  return keyFor(viewMode, 'records', 'Records');
}

export function getRecordsCountKey(viewMode) {
  return keyFor(viewMode, 'recordsCount', 'RecordsCount');
}

export function getRecordsCountNewMessagesKey(viewMode) {
  return keyFor(viewMode, 'recordsCountNewMessages', 'RecordsCountNewMessages');
}

export function getAllRecordsLoadedKey(viewMode) {
  return keyFor(viewMode, 'allRecordsLoaded', 'AllRecordsLoaded');
}

export function getLoadingKey(viewMode) {
  return keyFor(viewMode, 'loading', 'Loading');
}

export function getLoadingErrorKey(viewMode) {
  return keyFor(viewMode, 'loadingError', 'LoadingError');
}

export function getQueryKey(viewMode) {
  return keyFor(viewMode, 'query', 'Query');
}
